module.exports = "/usb-c57aebb34efdad4510ed70350738e279d.jpg";